import Layout from "@/components/Layout";
import { Ship, Target, Eye, Gauge } from "lucide-react";

const TEAM = "https://images.unsplash.com/photo-1542744173-8e7e53415bb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHRlYW0lMjBtZWV0aW5nfGVufDB8fHx8MTc4NjcwMjQzNXww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <Layout>
      <div className="bg-navy text-white py-16">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 max-w-4xl">
          <span className="font-mono-data text-signal text-xs">ABOUT VK FORWARDERS</span>
          <h1 className="font-heading font-extrabold text-3xl sm:text-5xl mt-3 leading-tight">
            A technology-enabled freight forwarding partner.
          </h1>
          <p className="text-white/60 mt-4 text-lg">
            Helping exporters and importers make faster and smarter shipping decisions —
            with transparency, speed and rate comparison at the core.
          </p>
          <p className="font-heading font-bold text-signal mt-6 text-xl">Planning Logistics, Moving Cargo, Delivering Trust.</p>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-16 grid lg:grid-cols-2 gap-12 items-center">
        <img src={TEAM} alt="Business team" className="rounded-md border border-border w-full object-cover aspect-[4/3]" />
        <div className="space-y-6">
          {[
            { icon: Eye, t: "Transparency", d: "Ocean freight and local charges shown separately — no hidden costs, no surprises at booking." },
            { icon: Gauge, t: "Speed", d: "From route search to submitted enquiry in under a minute, powered by a live rate database." },
            { icon: Target, t: "Freight Expertise", d: "Container-wise, carrier-wise rates for dry and reefer cargo across major global trade lanes." },
          ].map((x) => (
            <div key={x.t} className="flex gap-4">
              <div className="h-11 w-11 shrink-0 bg-signal/10 border border-signal/30 rounded-sm flex items-center justify-center"><x.icon className="h-5 w-5 text-signal" /></div>
              <div>
                <h3 className="font-heading font-bold text-navy text-lg">{x.t}</h3>
                <p className="text-muted-foreground text-sm mt-1">{x.d}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
